/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse,
  DeleteGroupContact: (params: vp.DeleteGroupContactRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostDeleteGroupContact: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldDeleteGroupContact, setShouldDeleteGroupContact] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.DeleteGroupContactRequest>({
    ContactID: '',
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldDeleteGroupContact) return () => {};

    const PostDeleteGroupContact = async () => {
      setDataFetchingInfo(true, 'deleting group contact', 'fullScreen');
      const res = await api.postDeleteGroupContact(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldDeleteGroupContact) void PostDeleteGroupContact();
    setShouldDeleteGroupContact(false);
    return () => {
      source.cancel();
    };
  }, [shouldDeleteGroupContact]);

  return [
    response,
    (_params: vp.DeleteGroupContactRequest) => {
      setParams(_params);
      setShouldDeleteGroupContact(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldDeleteGroupContact(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostDeleteGroupContact);